<div class="w-full space-y-6">

  <!-- Page Header -->
  <div class="flex items-center justify-between pb-4 border-b border-slate-200">
    <div class="flex items-center gap-3">
      <div class="h-10 w-10 bg-slate-100 rounded-lg flex items-center justify-center">
        <mat-icon class="text-slate-600">description</mat-icon>
      </div>
      <div>
        <h2 class="text-sm font-bold tracking-widest uppercase text-slate-800">
          Template Master
        </h2>
        <p class="text-xs text-slate-500 font-medium mt-0.5">
          Manage SMS templates
        </p>
      </div>
    </div>
  </div>

  <!-- FORM CARD -->
  <div class="bg-white rounded-lg shadow border border-slate-200 px-6 py-4">

    <div class="flex flex-col gap-4 md:flex-row md:items-baseline md:gap-6">

      <!-- Template Name -->
      <mat-form-field appearance="outline" class="w-full md:w-64">
        <mat-label>Template Name</mat-label>
        <mat-icon matPrefix class="text-slate-500 mr-2">dashboard</mat-icon>
        <input matInput [(ngModel)]="l_formData.templateName" required />
      </mat-form-field>

      <!-- Template ID -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>DLT Template ID</mat-label>
        <mat-icon matPrefix class="text-slate-500 mr-2">badge</mat-icon>
        <input matInput [(ngModel)]="l_formData.dltTemplateId" name="dltTemplateId" placeholder="Enter Template ID"
          required />
      </mat-form-field>

      <!-- Template Message -->
      <mat-form-field appearance="outline" class="w-full md:flex-1">
        <mat-label>Template Message</mat-label>
        <mat-icon matPrefix class="text-slate-500 mr-3">message</mat-icon>
        <textarea matInput rows="1" class="resize-none" [(ngModel)]="l_formData.templateMsg" required></textarea>
      </mat-form-field>

      <!-- Active -->
      <div class="flex items-center">
        <mat-checkbox [(ngModel)]="l_formData.templateIsActive">
          <span class="text-[12px] font-semibold tracking-widest uppercase text-slate-700">
            Active
          </span>
        </mat-checkbox>
      </div>

      <!-- Reset -->
      <button (click)="lFN_ResetForm();" class="flex-1 md:flex-none px-6 py-2.5 rounded-lg
                    text-slate-500 text-[12px] font-medium tracking-widest uppercase
                    bg-slate-100 text-slate-900
                    transition-all duration-200">
        {{ 'Reset' }}
      </button>

      <!-- Submit -->
      <button (click)="lFN_SubmitForm()" class="px-6 py-2 rounded-md
         bg-gradient-to-r from-slate-900 to-black
         text-white text-[12px] font-medium tracking-widest uppercase
         shadow hover:from-black hover:to-slate-800
         transition-all duration-150 whitespace-nowrap">
        {{ isEditMode ? 'Update' : 'Save' }}
      </button>



    </div>

  </div>


  <!-- TABLE CARD -->
  <div class="bg-white rounded-lg shadow border border-slate-200 overflow-x-auto">

    <table mat-table [dataSource]="dataSource" class="w-full">

      <!-- Sr No. -->
      <ng-container matColumnDef="srNo">
        <th mat-header-cell *matHeaderCellDef
          class="bg-gray-900 text-white text-xs uppercase text-center px-4 w-[10%] whitespace-nowrap">Sr No.</th>
        <td mat-cell *matCellDef="let row; let i = index" class="text-center text-sm px-4 whitespace-nowrap">{{ i + 1 }}
        </td>
      </ng-container>


      <!-- Template Name -->
      <ng-container matColumnDef="templateName">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs px-4 whitespace-nowrap">
          Template Name
        </th>
        <td mat-cell *matCellDef="let t" class="text-sm px-4 whitespace-nowrap">
          {{ t.templateName }}
        </td>
      </ng-container>

      <!-- Template ID Column -->
      <ng-container matColumnDef="dltTemplateId">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs px-4 whitespace-nowrap">
          DLT Template ID </th>
        <td mat-cell *matCellDef="let element" class="text-sm px-4 whitespace-nowrap"> {{element.dltTemplateId}} </td>
      </ng-container>


      <!-- Message -->
      <ng-container matColumnDef="templateMsg">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs px-4 whitespace-nowrap">
          Template Message
        </th>
        <td mat-cell *matCellDef="let t"
          class="text-sm text-slate-700 whitespace-normal leading-relaxed px-4 min-w-[250px]">
          {{ t.templateMsg }}
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="templateIsActive">
        <th mat-header-cell *matHeaderCellDef
          class="bg-gray-900 text-white uppercase text-xs text-center px-4 whitespace-nowrap">
          Status
        </th>

        <td mat-cell *matCellDef="let t" class="text-center px-4 whitespace-nowrap">
          <button (click)="lFN_ChangeTemplateStatus(t)" class="w-20 text-center
                  px-0 py-1.5 rounded-full text-[10px] font-semibold tracking-widest uppercase
                  transition-all duration-200 border" [ngClass]="t.templateIsActive === 'YES'
                  ? 'bg-emerald-200 text-emerald-900 border border-emerald-600 hover:bg-emerald-300'
                  : 'bg-rose-200 text-rose-900 border border-rose-600 hover:bg-rose-300'">

            {{ t.templateIsActive === 'YES' ? 'Active' : 'Inactive' }}
          </button>
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef
          class="bg-gray-900 text-white uppercase text-xs text-center px-4 whitespace-nowrap">
          Actions
        </th>
        <td mat-cell *matCellDef="let t" class="text-center px-4 whitespace-nowrap">
          <button mat-icon-button (click)="lFN_EditTemplate(t)">
            <mat-icon class="text-black">edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <mat-paginator [pageSizeOptions]="[10,20,30]" showFirstLastButtons></mat-paginator>

  </div>

</div>